<template>
    <div>
      <KeepAlive>
        <component v-if="currentEvent" :ref="currentEvent.name" v-bind:is="currentEvent" :card="card" :selectedCards="[card.id]" :modalType="'add'" :eventManager="{'cascate': true, 'hasNext': this.events.length > 1}" @Submit="handleOk" @Abort="handleCancel"></component>
      </KeepAlive>
    </div>
</template>
<script>
import eventoA from '@/views/private/crm/details/followup/followup.vue'
import eventoB from '@/views/private/crm/details/product/modal/productmodal.vue'
import eventoC from '@/views/private/cobranca/modal/asign/addAsign.vue'

const events = {
  1: eventoA,
  2: eventoB,
  3: eventoC
}

export default {
  name: 'EventManager',
  data () {
    return {
      events: [],
      submitEvents: [],
      currentEvent: null
    }
  },
  props: {
    eventsToShow: Array,
    card: Object
  },
  created () {
    this.events = [...this.eventsToShow]
  },
  watch: {
    events: function (newVal) {
      this.currentEvent = events[this.events[0]]
      if (this.currentEvent.name === 'ProductModal') {
        this.$nextTick(() => {
          this.$refs.ProductModal.showModal() // OPEN THE COMPONENT MODAL
        })
      } else if (this.currentEvent.name === 'AddAsignModal') {
        this.$nextTick(() => {
          this.$refs.AddAsignModal.showModal() // OPEN THE COMPONENT MODAL
        })
      }
    }
  },
  methods: {
    handleOk (event) {
      this.submitEvents.push(event) // PUSHES A FUNCTION SENT VIA EMIT INTO THE ARRAY
      if (this.events.length > 1) this.handleNext() // IF THERE'S NO PENDENT EVENT, SUBMIT ALL
      else this.handleSubmit()
    },
    handleCancel (event) {
      this.$emit('Aborted')
    },
    handleNext () {
      this.events.shift() // REMOVES THE FIRST EVENT
    },
    handleSubmit () {
      Promise.all(this.submitEvents.map(event => event()))
        .then(() => {
          this.$emit('Submited')
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/event/EventManager.vue